import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useEditAssignmentMutation,
  useGetAssignmentQuery,
} from "../../features/assignments/assignemntsApi";
import { useGetVideosQuery } from "../../features/videos/videosApi";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import styles from "./assignmentForm.module.css";

export default function AssignmentEditForm() {
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const titleRef = useRef();
  const chooseVideoRef = useRef();
  const totalMarkRef = useRef();

  const { data: videos } = useGetVideosQuery();
  const {
    data: assignment,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetAssignmentQuery(assignmentId, {
    refetchOnMountOrArgChange: true,
  });
  const [editAssignment, { isSuccess: isEditSuccess }] =
    useEditAssignmentMutation();

  const handleEdit = (e) => {
    e.preventDefault();
    const videoTitle = videos?.find(
      (video) => video.id === Number(chooseVideoRef.current.value)
    ).title;
    const data = {
      title: titleRef?.current.value,
      video_id: chooseVideoRef.current.value,
      video_title: videoTitle,
      totalMark: totalMarkRef.current.value,
    };

    editAssignment({ assignmentId, data });
  };

  useEffect(() => {
    if (isSuccess && titleRef?.current) {
      // set the value of all the inputs
      titleRef.current.value = assignment?.title;
      chooseVideoRef.current.value = assignment?.video_id;
      totalMarkRef.current.value = assignment?.totalMark;
    }
    if (isEditSuccess) {
      navigate("/admin/assignment");
    }
  });

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && assignment?.id) {
    content = (
      <form
        onSubmit={handleEdit}
        className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
      >
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="titleInput">Title</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="titleInput"
            ref={titleRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="chooseVideoSelect">Choose video</label>
          <select
            ref={chooseVideoRef}
            id="chooseVideoSelect"
            className="bg-slate-900 p-2 "
            defaultValue={1}
          >
            {videos?.map((video) => (
              <option value={video.id} key={video.id}>
                {video.title}
              </option>
            ))}
          </select>
        </div>

        <div className="formGroup flex items-center justify-between">
          <label htmlFor="TotalMarkInput">Total Mark</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="number"
            id="TotalMarkInput"
            ref={totalMarkRef}
          />
        </div>

        <button
          type="submit"
          className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
        >
          Save
        </button>
      </form>
    );
  }
  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        {content}
      </div>
    </>
  );
}
